import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawClassLinkIcon from "./RawClassLinkIcon.svg.jsx";

const ClassLink = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawClassLinkIcon} {...props} />;
});

export default ClassLink;
